/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useCallback } from "react";
import { GblContext } from "providers/formatter";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import clsx from "clsx";
import { Loading, useRedirect, useTranslate } from "react-admin";
import { Paper, Grid } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { TableHead, TableFooter, TableRow, TableCell, Tooltip } from "@material-ui/core";
import { TableHead as MuiTableHead } from "mui-datatables";
import MuiTranslateTable from "components/MuiTranslateTable";
import ActionMenu from "components/ActionMenu";
import BoxHeader from "components/BoxHeader";
import ButtonFooter from "components/ButtonFooter";
import NavRight from "components/NavRightSide";
import PopupTable from "components/PopupTable";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import { getAllocationJvDetail, updateAllocationJvDetail } from "services/generalLedger";
import { getActiveDimListByModuleName } from "services/dimension";
import SnackbarUtils from "utils/SnackbarUtils";

const Edit = (props) => {
  const translate = useTranslate();
  const classes = props.useStyles();
  const { basePath, id, formFields, formFieldsDetail } = props;
  const redirect = useRedirect();
  const [isBtnLoading, setBtnLoading] = useState(false);
  const { settingAll, NumberFormat, ToNumber, FixedSumValue } = useContext(GblContext);
  const { SettingSystem } = settingAll;
  const [data, setData] = useStateWithCallbackLazy();
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  const [openDim, setOpenDim] = useState(false);

  const [initNewRow, setInitNewRow] = useState({
    index: -1,
    AJvhSeq: -1,
    AJvdSeq: -1,
    DeptCode: "",
    AccCode: "",
    Description: "",
    CurCode: SettingSystem.DefaultCurrencyCode,
    CurRate: SettingSystem.DefaultCurrencyRate,
    CrQty: 0,
    CrAmount: 0,
    CrBase: 0,
    DrQty: 0,
    DrAmount: 0,
    DrBase: 0,
    IsOverWrite: true,
    DimList: {
      Dim: [],
    },
  });

  const menuControlProp = [
    { name: "Back", fnc: () => redirect("list", basePath) },
    { name: "Add", disabled: true },
    { name: "Edit", disabled: true },
    { name: "Delete", disabled: true },
    { name: "Copy", disabled: true },
  ];

  const methods = useForm({ defaultValues: data });

  const { handleSubmit, getValues, reset } = methods;

  const fetchDimListByModule = useCallback(async (mounted) => {
    const { Data } = await getActiveDimListByModuleName(10, 1, "GL-D");
    setInitNewRow((state) => ({
      ...state,
      DimList: {
        Dim: Data,
      },
    }));
    if (mounted) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    async function fetchJvById() {
      const response = await getAllocationJvDetail(id);
      if (response) {
        setData(response);
        reset(response);
      }
      if (mounted) {
        setLoading(false);
      }
    }
    fetchJvById();
    fetchDimListByModule(mounted);
    return function cleanup() {
      mounted = false;
    };
  }, []);

  function useForceUpdate() {
    const [value, setState] = useState(true);
    return () => setState(!value);
  }

  const forceUpdate = useForceUpdate();

  const disableFormEnter = (e) => {
    if (e.key === "Enter" && e.target.localName !== "textarea") e.preventDefault();
  };

  const onSubmit = async () => {
    const values = getValues();
    setBtnLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 500));
    setData(
      (state) => ({
        ...state,
        ...values,
      }),
      (nextState) => Save(nextState)
    );
  };

  const AddNewRow = () => {
    setEditIndex("");
    setShowAdd(true);
  };

  const UpdateRow = (value) => {
    setEditIndex(value);
    setShowAdd(true);
  };

  const DisableUnit = () => {
    if (data.Detail.length > 0) {
      document.getElementsByName("AllocateUnit")[0].parentNode.parentNode.firstChild.classList.add("Mui-disabled");
      document.getElementsByName("AllocateUnit")[0].parentNode.classList.add("Mui-disabled");
      document.getElementsByName("AllocateUnit")[0].disabled = true;
    } else {
      document.getElementsByName("AllocateUnit")[0].parentNode.parentNode.firstChild.classList.remove("Mui-disabled");
      document.getElementsByName("AllocateUnit")[0].parentNode.classList.remove("Mui-disabled");
      document.getElementsByName("AllocateUnit")[0].disabled = false;
    }
  };

  const CalculateAllocation = (arrDetail) => {
    const values = methods.watch();
    const allocateAmt = ToNumber(values.AllocateAmt);
    const sumDrBase = arrDetail.reduce((accu, item) => {
      const s = ToNumber(accu) + ToNumber(item.DrBase);
      return NumberFormat(s ?? 0);
    }, 0);
    const sumCrBase = arrDetail.reduce((accu, item) => {
      const s = ToNumber(accu) + ToNumber(item.CrBase);
      return NumberFormat(s ?? 0);
    }, 0);
    //DR
    if (ToNumber(sumDrBase) > allocateAmt) {
      let excessAmt = ToNumber(sumDrBase) - allocateAmt;
      let DIndex = arrDetail.findLastIndex((i) => i.DrQty > 0);
      let lastDebitDetail = arrDetail[DIndex];

      if (lastDebitDetail?.DrAmount) {
        lastDebitDetail.DrAmount = ToNumber(lastDebitDetail.DrAmount) - excessAmt;
        lastDebitDetail.DrBase = ToNumber(lastDebitDetail.DrAmount) * lastDebitDetail.CurRate;
        arrDetail[DIndex] = lastDebitDetail;
      }
    }
    if (ToNumber(sumDrBase) < allocateAmt) {
      let excessAmt = allocateAmt - ToNumber(sumDrBase);
      let DIndex = arrDetail.findLastIndex((i) => i.DrQty > 0);
      let lastDebitDetail = arrDetail[DIndex];

      if (lastDebitDetail?.DrAmount) {
        lastDebitDetail.DrAmount = ToNumber(lastDebitDetail.DrAmount) + excessAmt;
        lastDebitDetail.DrBase = ToNumber(lastDebitDetail.DrAmount) * lastDebitDetail.CurRate;
        arrDetail[DIndex] = lastDebitDetail;
      }
    }
    //CR
    if (ToNumber(sumCrBase) > allocateAmt) {
      let excessAmt = ToNumber(sumCrBase) - allocateAmt;
      let CIndex = arrDetail.findLastIndex((i) => i.CrQty > 0);
      let lastCreditDetail = arrDetail[CIndex];

      if (lastCreditDetail?.CrAmount) {
        lastCreditDetail.CrAmount = ToNumber(lastCreditDetail.CrAmount) - excessAmt;
        lastCreditDetail.CrBase = ToNumber(lastCreditDetail.CrAmount) * lastCreditDetail.CurRate;
        arrDetail[CIndex] = lastCreditDetail;
      }
    }

    if (ToNumber(sumCrBase) < allocateAmt) {
      let excessAmt = allocateAmt - ToNumber(sumCrBase);
      let CIndex = arrDetail.findLastIndex((i) => i.CrQty > 0);
      let lastCreditDetail = arrDetail[CIndex];

      if (lastCreditDetail?.CrAmount) {
        lastCreditDetail.CrAmount = ToNumber(lastCreditDetail.CrAmount) + excessAmt;
        lastCreditDetail.CrBase = ToNumber(lastCreditDetail.CrAmount) * lastCreditDetail.CurRate;
        arrDetail[CIndex] = lastCreditDetail;
      }
    }
  };

  const UpdateForm = (e) => {
    const values = methods.watch();
    if (data.Detail.length !== 0 && e.target.name === "AllocateAmt" && e.target.name === "AllocateUnit") {
      const allocateAmt = ToNumber(values.AllocateAmt);
      const allocateUnit = ToNumber(values.AllocateUnit);
      data.Detail.forEach((i, idx) => {
        i.index = idx;
        const drQty = ToNumber(i["DrQty"]);
        const crQty = ToNumber(i["CrQty"]);
        const curRate = ToNumber(i["CurRate"]);
        if (drQty > 0) {
          const drAmount = (allocateAmt / allocateUnit) * drQty;
          const drBase = drAmount * curRate;

          i.DrAmount = drAmount;
          i.DrBase = drBase;
        }
        if (crQty > 0) {
          const crAmount = (allocateAmt / allocateUnit) * crQty;
          const crBase = crAmount * curRate;
          i.CrAmount = crAmount;
          i.CrBase = crBase;
        }
      });

      CalculateAllocation(data.Detail);

      methods.setValue("AllocateAmt", allocateAmt);
      methods.setValue("AllocateUnit", allocateUnit);
    }
  };

  const SaveFromPopup = (arr, row) => {
    const index = arr.Detail.findIndex((el) => el.index === editIndex);

    if (editIndex !== "") {
      //update
      arr.Detail[index] = row;
      const sumDrQty = arr.Detail.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.DrQty);
        return s ?? 0;
      }, 0);

      const sumCrQty = arr.Detail.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.CrQty);
        return s ?? 0;
      }, 0);

      if (arr.AllocateUnit === sumDrQty && arr.AllocateUnit === sumCrQty) {
        CalculateAllocation(arr.Detail);
      }
      setShowAdd(false);
    } else {
      //create
      row.index = arr.Detail.length;
      arr.Detail = [...arr.Detail, row];
      const sumDrQty = arr.Detail.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.DrQty);
        return s ?? 0;
      }, 0);

      const sumCrQty = arr.Detail.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.CrQty);
        return s ?? 0;
      }, 0);

      if (arr.AllocateUnit === sumDrQty && arr.AllocateUnit === sumCrQty) {
        CalculateAllocation(arr.Detail);
      }
      setShowAdd(false);
    }
    DisableUnit();
  };

  const CancelFromPopup = () => {
    setShowAdd(false);
  };

  const columns = [
    {
      name: "index",
      label: " ",
      options: {
        filter: false,
        viewColumns: false,
        customBodyRender: (value) => {
          return (
            <>
              <EditIcon
                fontSize="small"
                color="primary"
                style={{ cursor: "pointer", marginLeft: 10 }}
                onClick={() => UpdateRow(value)}
              />
            </>
          );
        },
      },
    },
    {
      name: "DeptCode",
      label: "Dept.",
    },
    {
      name: "AccCode",
      label: "Account #",
    },
    {
      name: "AccDesc",
      label: "Account Name",
    },
    {
      name: "Description",
      label: "Comment",
      options: {
        display: false,
        customBodyRender: (val) => {
          return (
            <Tooltip title={<p style={{ fontSize: 14 }}>{val}</p>} arrow placement="top">
              <div className={classes.divComment}>
                <div className={classes.parentStyle}>
                  <div className={classes.cellStyleEllipsis}>{val}</div>
                </div>
              </div>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "CurCode",
      label: "Currency",
    },
    {
      name: "CurRate",
      label: "Rate",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value, "currency");
        },
      },
    },
    {
      name: "DrQty",
      label: "Unit",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value, tableMeta) => {
          if (value > 0) {
            return NumberFormat(value);
          } else {
            return NumberFormat(data.Detail[tableMeta.rowIndex].CrQty);
          }
        },
      },
    },
    {
      name: "DrAmount",
      label: "Dr. Amount",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "CrAmount",
      label: "Cr. Amount",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "DrBase",
      label: "Dr. Base",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "CrBase",
      label: "Cr. Base",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "DimList",
      label: "DimList",
      options: {
        display: false,
      },
    },
  ];

  const footerClasses = clsx({
    [classes.footerCell]: true,
    [classes.stickyFooterCell]: true,
  });

  const options = {
    responsive: "standard",
    selectableRows: "multiple",
    fixedHeader: true,
    tableBodyHeight: "580px",
    search: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    elevation: 0,
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    pagination: false,
    customTableBodyFooterRender: function (opts) {
      const sumDrAmt = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[8]);
        return NumberFormat(s ?? 0);
      }, 0);

      const sumCrAmt = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[9]);
        return NumberFormat(s ?? 0);
      }, 0);

      const sumDrBase = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[10]);
        return NumberFormat(s ?? 0);
      }, 0);

      const sumCrBase = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[11]);
        return NumberFormat(s ?? 0);
      }, 0);
      return (
        <TableFooter className={footerClasses}>
          <TableRow>
            {/* Add TableCellEmpty For Summary Space */}
            <TableCell className={footerClasses} />
            {opts.columns.map((col, index) => {
              if (col.display === "true") {
                if (col.name === "DrAmount") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumDrAmt}
                    </TableCell>
                  );
                } else if (col.name === "CrAmount") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumCrAmt}
                    </TableCell>
                  );
                } else if (col.name === "DrBase") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumDrBase}
                    </TableCell>
                  );
                } else if (col.name === "CrBase") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumCrBase}
                    </TableCell>
                  );
                } else {
                  return <TableCell key={index} className={footerClasses} />;
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
    onRowsDelete: (rowsDeleted) => {
      const removeArray = rowsDeleted.data.map((i) => i.index);
      for (let i = removeArray.length - 1; i >= 0; i--) data.Detail.splice(removeArray[i], 1);
      DisableUnit();
    },
  };

  const CustomHeader = (props) => {
    return (
      <>
        <TableHead>
          <TableRow>
            <TableCell align="center" colSpan={1}>
              <IconButton size={"small"} onClick={() => AddNewRow()} style={{ marginLeft: 6 }}>
                <AddIcon />
              </IconButton>
            </TableCell>
            <TableCell align="right" colSpan={10} />
          </TableRow>
        </TableHead>
        <MuiTableHead {...props} />
      </>
    );
  };

  const CheckDrCr = (field, m, dataItem) => {
    let CurRate = ToNumber(dataItem["CurRate"]);
    let allocateAmt = getValues("AllocateAmt") ? ToNumber(getValues("AllocateAmt")) : 0;
    let allocateUnit = getValues("AllocateUnit") ? ToNumber(getValues("AllocateUnit")) : 0;
    let drQty = ToNumber(dataItem["DrQty"]);
    let crQty = ToNumber(dataItem["CrQty"]);
    let drAmount = (allocateAmt / allocateUnit) * drQty;
    let crAmount = (allocateAmt / allocateUnit) * crQty;

    const sumDrQty = data.Detail.reduce((accu, item) => {
      const s = ToNumber(accu) + ToNumber(item.DrQty);
      return s ?? 0;
    }, 0);

    const sumDrBase = data.Detail.reduce((accu, item) => {
      const s = ToNumber(accu) + ToNumber(item.DrBase);
      return NumberFormat(s ?? 0);
    }, 0);

    const sumCrQty = data.Detail.reduce((accu, item) => {
      const s = ToNumber(accu) + ToNumber(item.CrQty);
      return s ?? 0;
    }, 0);

    const sumCrBase = data.Detail.reduce((accu, item) => {
      const s = ToNumber(accu) + ToNumber(item.CrBase);
      return NumberFormat(s ?? 0);
    }, 0);

    if (sumDrQty === allocateUnit - 1) {
      drAmount = allocateAmt - ToNumber(sumDrBase);
    }

    if (sumCrQty === allocateUnit - 1) {
      crAmount = allocateAmt - ToNumber(sumCrBase);
    }

    if (field === "DrQty" && dataItem[field] != 0) {
      m.setValue("DrAmount", drAmount);
      m.setValue("DrBase", drAmount * CurRate);
      m.setValue("CrQty", 0);
      m.setValue("CrAmount", 0);
      m.setValue("CrBase", 0);
    }
    if (field === "CrQty" && dataItem[field] != 0) {
      m.setValue("CrAmount", crAmount);
      m.setValue("CrBase", crAmount * CurRate);
      m.setValue("DrQty", 0);
      m.setValue("DrAmount", 0);
      m.setValue("DrBase", 0);
    }
  };

  const CheckValueBeforePost = (values) => {
    if (values.Detail.length > 0) {
      const sumDrBase = values.Detail.reduce((total, cur) => {
        return FixedSumValue(ToNumber(total) + ToNumber(cur.DrBase));
      }, 0);
      const sumCrBase = values.Detail.reduce((total, cur) => {
        return FixedSumValue(ToNumber(total) + ToNumber(cur.CrBase));
      }, 0);

      const sumDrQty = values.Detail.reduce((total, cur) => {
        return FixedSumValue(ToNumber(total) + ToNumber(cur.DrQty));
      }, 0);

      const sumCrQty = values.Detail.reduce((total, cur) => {
        return FixedSumValue(ToNumber(total) + ToNumber(cur.CrQty));
      }, 0);

      if (ToNumber(sumDrBase) !== ToNumber(sumCrBase)) {
        SnackbarUtils.warning(translate("ra.info.Unbalanced"));
        setBtnLoading(false);
        return false;
      }

      if (ToNumber(sumDrBase) !== ToNumber(values.AllocateAmt)) {
        SnackbarUtils.warning(`Total amount must equal to Amount to Allocated ${values.AllocateAmt}`);
        setBtnLoading(false);
        return false;
      }

      if ((ToNumber(sumDrQty) + ToNumber(sumCrQty)) / 2 !== ToNumber(values.AllocateUnit)) {
        SnackbarUtils.warning(`Total Qty Dr or Cr must be equal with Allocated Unit ${values.AllocateUnit}`);
        setBtnLoading(false);
        return false;
      }

      const foundZeroItem = values.Detail.filter(
        (item) => ToNumber(item.DrAmount) === 0 && ToNumber(item.CrAmount) === 0
      );
      if (foundZeroItem.length > 0) {
        const msg = `Amount cannot be zero, would you like to remove transaction(s) ? 
        Note: All transactions with no amounts will be deleted.`;
        SnackbarUtils.confirm(
          msg,
          function () {
            const indexList = foundZeroItem.map((i) => i.index);
            for (let i = indexList.length - 1; i >= 0; i--) {
              values.Detail.splice(indexList[i], 1);
            }
            forceUpdate();
            Save(values);
          },
          function () {
            setBtnLoading(false);
          }
        );
      } else {
        return true;
      }
    } else {
      SnackbarUtils.info(translate("ra.info.notransaction"));
      setBtnLoading(false);
      return;
    }
  };

  const Save = async (values) => {
    const isPass = CheckValueBeforePost(values);
    if (isPass) {
      SaveFnc(values);
    } else {
      setLoading(false);
    }
  };

  const SaveFnc = async (values) => {
    setBtnLoading(false);
    const { Code, InternalMessage, UserMessage } = await updateAllocationJvDetail(values);
    if (Code === 0) {
      SnackbarUtils.success(UserMessage, function () {
        redirect("show", basePath, id, values);
      });
      setBtnLoading(false);
    } else {
      setBtnLoading(false);
      if (InternalMessage) {
        SnackbarUtils.error(InternalMessage);
      } else {
        SnackbarUtils.warning(UserMessage);
      }
    }
  };

  const ShowDim = (values) => {
    if (!values) {
      setOpenDim(!openDim);
    } else {
      setOpenDim(!openDim);
    }
  };

  const CancelFnc = () => {
    redirect("show", basePath, id);
  };

  if (loading) return <Loading />;
  if (!data) return null;

  return (
    <div
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: openDim,
        [classes.drawerClose]: !openDim,
      })}
    >
      <ActionMenu menuControl={menuControlProp} />

      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={disableFormEnter}>
        <Paper style={{ padding: 16 }}>
          <BoxHeader header={"Allocation Voucher"} source={data.JvhSource} status={data.Status} />
          <Grid container alignItems="flex-start" spacing={1}>
            {formFields
              ? formFields.map((item, idx) => (
                  <Grid item xs={item.size} key={idx}>
                    {React.createElement(item.field.type, {
                      ...{
                        ...item.field.props,
                        methods,
                        key: item.field.props.name,
                        onChange: UpdateForm,
                      },
                    })}
                  </Grid>
                ))
              : ""}
            <Grid item xs={12}>
              <MuiTranslateTable
                data={data.Detail}
                columns={columns}
                options={options}
                components={{
                  TableHead: CustomHeader,
                }}
              />
              {showAdd && (
                <PopupTable
                  initialValues={editIndex !== "" ? data.Detail.find((i) => i.index === editIndex) : initNewRow}
                  formFields={formFieldsDetail}
                  update={CheckDrCr}
                  open={showAdd}
                  save={(row) => SaveFromPopup(data, row)}
                  cancel={CancelFromPopup}
                  showDim
                />
              )}
            </Grid>
          </Grid>
        </Paper>
        <pre>{process.env.NODE_ENV === "development" ? JSON.stringify(data, 0, 2) : ""}</pre>
        <ButtonFooter disabled={isBtnLoading} CancelFnc={CancelFnc} />
      </form>

      <NavRight
        open={openDim}
        close={() => setOpenDim(false)}
        ShowDim={() => ShowDim()}
        module={"GL_AllocationJv"}
        moduleId={id}
      />
    </div>
  );
};

export default Edit;
